import {useEffect, useState} from 'react'

export const useDebounceArray = <T extends Iterable<unknown>>(
  value: T,
  delay: number,
  initialValue: T = value
) => {
  const [debouncedValue, setDebouncedValue] = useState(initialValue)

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedValue(value)
    }, delay)

    return () => {
      clearTimeout(handler)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [...value, delay])

  return delay > 0 ? debouncedValue : value
}

const useDebounce = <T>(value: T, delay: number, initialValue: T = value) =>
  useDebounceArray([value], delay, [initialValue])[0]

export default useDebounce
